<template lang="pug">
    div
        Card.card-shadow
            p(slot="title")
                Icon(type="md-contacts")
                |
                | Support
            p
                a(href="#") Help Center
            p
                a(href="#") Live Chat
            p
                a(href="#") Submit Ticket
            p
                a(:href="$store.state.frontendConfigs.userGuideUrl" target="_blank") User Guide
</template>
<script>
export default {
    name: "SupportCard",
    props: [],
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {};
    },
    methods: {},
    mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/Home/SupportCard.vue